module.exports = __webpack_public_path__ + "img/DE02851.205b7df8.png";